import { Tooltip } from "bootstrap";
import { clsx } from "clsx";
import { ReactElement, useRef, useEffect } from "react";
import { renderToString } from "react-dom/server";

export const AdditionalInfoButton = (props: {
    additionalInfo: ReactElement;
    linkWhite?: boolean;
    ignoreMargin?: boolean;
    placement?: "top" | "bottom" | "left" | "right";
}) => {
    const { additionalInfo, linkWhite, ignoreMargin, placement = "right" } = props;

    const additionalInfoRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (additionalInfoRef.current && additionalInfo) {
            Tooltip.getOrCreateInstance(additionalInfoRef.current).enable();
        }
    }, [additionalInfo]);

    return (
        <button
            title={renderToString(additionalInfo)}
            data-bs-placement={placement}
            data-bs-toggle="tooltip"
            tabIndex={-1}
            data-bs-html="true"
            ref={additionalInfoRef}
            type="button"
            className={clsx("btn btn-sm rounded-pill p-0", !ignoreMargin && "ms-3")}
        >
            <span className={clsx("fas fa-info-circle", linkWhite ? "text-white" : "text-secondary")}></span>
        </button>
    );
};
